import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_storage_configurationsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { name?: string, notes?: string, integration_name?: string, user_name?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, name?: string, value?: string, notes?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, integration_name?: string, user_name?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { name?: string, notes?: string, integration_name?: string, user_name?: string, $keys: string[] }): Promise<{ result?: { id?: string, name?: string, value?: string, notes?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, integration_name?: string, user_name?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      name?: string, notes?: string, integration_name?: string, user_name?: string    }) {
      return false;
    }
}
